import { BaseModel, Default, FormattedDateString, IsoString, StartOfDate } from '@red/data-access';
import { Expose, Transform, Type } from 'class-transformer';
import { BLANK_FORM_STATUSES } from '../data/blank-form.data';
import { PROJECT_PROPERTY_TYPES_OPTIONS } from '../data/project-type.data';
import { EAgentRole } from '../enums/agent-role.enum';
import { EBlankFormReferralSourceType, EBlankFormStatus, EBlankFormTypeDetail } from '../enums/blank_form.enum';
import { EManagementCommissionPdRole } from '../enums/management-commission.enum';
import { EProjectType } from '../enums/project-type.enum';
import { IBlankForm } from '../interfaces/blank-form.interface';
import { IBlankFormInternalCoBroke } from '../interfaces/blank-form-internal-co-broke.interface';
import { IBlankFormRelatedAgent } from '../interfaces/blank-form-related-agent.interface';
import { IPersonalParticular } from '../interfaces/personal-particular.interface';
import { IStatusDescription } from '../interfaces/status-description.interface';
import { KeysOfBlankFormHaveAgent } from '../types/blank-form.type';
import { OptionDescription } from '../types/option.type';
import { BlankFormBdModel } from './blank-form-bd.model';
import { BlankFormBuyerInfoModel, BlankFormBuyerModel } from './blank-form-buyer.model';
import { BlankFormIcModel } from './blank-form-ic.model';
import { BlankFormOtherFeeModel } from './blank-form-other-fee.model';
import { BlankFormPdModel } from './blank-form-pd.model';
import { BlankFormReferralModel } from './blank-form-referral.model';
import { BlankFormModel } from './blank-form.model';
import { BlankFormRelatedAgentModel } from './blank-form-related-agent.model';
import { BlankFormInternalCoBrokeModel } from './blank-form-internal-co-broke.model';

export class AgentBlankFormModel extends BaseModel {

  @Expose()
  blankForm!: BlankFormModel;

  @Expose()
  @Default([])
  @Type(() => BlankFormInternalCoBrokeModel)
  mains!: BlankFormInternalCoBrokeModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormInternalCoBrokeModel)
  leaders!: BlankFormInternalCoBrokeModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormInternalCoBrokeModel)
  internals!: BlankFormInternalCoBrokeModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormIcModel)
  bonuses!: BlankFormIcModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormIcModel)
  overridings!: BlankFormIcModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormIcModel)
  pools!: BlankFormIcModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormBdModel)
  bds!: BlankFormBdModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormPdModel)
  pds!: BlankFormPdModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormPdModel)
  pdOverrides!: BlankFormPdModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormPdModel)
  pdReferrals!: BlankFormPdModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormPdModel)
  pdManagements!: BlankFormPdModel[];

  @Expose()
  @Default([])
  @Type(() => BlankFormReferralModel)
  referrals!: BlankFormReferralModel[];

  @Expose()
  userAgentId!: number;

}
